<template>
  <div class="home" v-if="isShow">
    <!-- v-if="!isMobile" -->

    <el-row :class="[isShadowBg ? 'shadowBg' : '']" @click="changeShadow()" />
    <transition :duration="{ enter: 800, leave: 300 }" mode="out-in" name="el-fade-in-linear">
      <div :class="['left-navigation', isDisplayMenu ? 'collopse-menu' : '']" v-if="!isMobile || isDisplayMenu">
        <el-col class="el-col" :span="24">
          <el-menu active-text-color="#FFFFFF" background-color="#545c64" :default-active="$route.name" unique-opened router class="el-menu" text-color="#FFF" @open="handleOpen" @close="handleClose">
            <div class="company-header">
              <Avatar :size="40" :src="companyData && companyData.companyLogo ? companyData.companyLogo : defaultHeaderImg" :color="avatarColor" :can-edit="false"></Avatar>
              <div class="header-info">
                <span>{{ companyName }}</span>
                <p>{{ $t('Company') }}</p>
              </div>
            </div>
            <el-menu-item index="companyHome" route="/company/management/home">
              <img src="@/assets/enterprise-Overview.png" alt="" />
              <span>{{ $t('Company Overview') }}</span>
            </el-menu-item>
            <el-menu-item index="companyStaff" route="/company/management/members">
              <img src="@/assets/employee-Management.png" alt="" />
              <span>{{ $t('Member Management') }}</span>
            </el-menu-item>
            <!-- 订单管理 -->
            <el-menu-item index="companyOrder" route="/company/management/order" v-if="!isFloatAuth">
              <img src="@/assets/approval-Management.png" alt="" />
              <span>{{ $t('Order') }}</span>
            </el-menu-item>
            <el-menu-item index="companySettings" route="/company/management/settings">
              <img src="@/assets/settings.png" alt="" />
              <span>{{ $t('Company Settings') }}</span>
            </el-menu-item>
            <div class="company-header bottom-header" v-if="!isMobile && false">
              <img src="@/assets/management-company-icon.png" alt="" />
              <span>{{ companyName }}</span>
            </div>
          </el-menu>
        </el-col>
      </div>
    </transition>
    <div class="right-container" v-loading="userInfoLoading">
      <div class="organize-banner" v-if="organizeExpiredTime <= 30 && isFloatingCompany == 2 && isCloseBanner">
        {{ bannerExpireTip }}
        <span class="close-icon" @click="isCloseBanner = false"></span>
      </div>
      <div class="container">
        <div class="head-portrait">
          <div class="menu-img-wrapper" @click="handleCollopse" v-if="isMobile">
            <img src="@/assets/management-menu.png" alt="" class="menu-img" />
          </div>
          <el-popover placement="top-start" :width="poperWidth" trigger="hover">
            <template #reference>
              <!-- <img src="@/assets/management-logo.png" :alt="$t('headerImg')" /> -->
              <div class="avatar">
                <Avatar :size="40" :company-user="true" :src="companyStore.userLogo" :color="avatarColor" :nickname="nickName" :can-edit="false"></Avatar>
              </div>
              <!-- <div>nihao</div> -->
            </template>
            <div :class="`img-function ${appStore.language}`" @click="handleLogOut">
              <img src="@/assets/sign-out.png" alt="" />
              <span :class="`sign-out ${appStore.language} `"> &nbsp;{{ $t('Sign Out') }}</span>
            </div>
          </el-popover>
        </div>

        <router-view v-if="isDisplayContent && !userInfoLoading" v-slot="{ Component }" :key="refreshKey">
          <component :is="Component" :organizeExpiredTime="organizeExpiredTime" :isFloatingCompany="isFloatingCompany" :companyData="companyData" :avatorColor="avatarColor" @on-name-change="getData" :key="refreshKey" />
        </router-view>
        <div class="permission-box" v-else>
          <div class="permission-inner">
            <img class="permission-img" src="@/assets/no-permission-img.png" alt="" />
            <p class="permission-text">
              {{ $t('You are not an administrator and do not have permission to access this page.') }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { getCompanyDetail } from '@/api/company/company'
import { getUserInfo, logOut } from '@/api/user/user'
import defaultHeaderImg from '@/assets/management-company-icon.png'
import Avatar from '@/components/user/avatar.vue'
import usePlat from '@/hook/usePlat'
import { isLogin, redirectToLogin } from '@/services/base'
import { logOutSuccess } from '@/services/login'
import { appStore, companyStore, userStore } from '@/stores'
import { computed, getCurrentInstance, onMounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'

const store = useStore()
const isDisplayContent = ref(true)
const userInfoLoading = ref(true)
const isShow = ref(true)
const isExpired = ref(false)
const refreshKey = ref(0)
watch(
  () => companyStore.hasPermission,
  () => {
    isDisplayContent.value = companyStore.hasPermission
  }
)
const organizeExpiredTime = ref()
const { isMobile } = usePlat()
const isDisplayMenu = ref(false)
const isShadowBg = ref(false)
const nickName = ref(false)
const avatarColor = ref()
const isFloatingCompany = ref(0)
const isCloseBanner = ref(true)
const handleCollopse = () => {
  isDisplayMenu.value = !isDisplayMenu.value
  isShadowBg.value = isDisplayMenu.value
}

const poperWidth = computed(() => {
  if (appStore.language === 'fr-FR') {
    return 208
  } else {
    return 128
  }
})

const getUserData = async () => {
  try {
    const res = await getUserInfo()
    if (res) {
      nickName.value = res.data.userInfo && res.data.userInfo.nickName
      avatarColor.value = res.data.userInfo && res.data.userInfo.color
      Object.assign(userStore.userInfo, res.data.userInfo)
      if (res.data && res.data.userInfo && res.data.userInfo.headerImg) {
        store.commit('setUserLogo', res.data.userInfo.headerImg)
      }
      // 登录成功判断该企业是否使用zga域名接口
      if (res.data.userInfo.companyUser && !res.data.userInfo?.companyInfo?.useZga) {
        appStore.useZgaApi = true
        refreshKey.value++
      }
    }
  } catch (e) {
    console.log(e)
  }
  userInfoLoading.value = false
}

getUserData()

const changeShadow = () => {
  handleCollopse()
}

onMounted(() => {
  document.title = $t('Enterprise management background')
})

const companyData = ref()
const handleLogOut = () => {
  logOut().finally(() => {
    logOutSuccess(true, true)
  })
}

if (!isLogin()) {
  console.log('isnotlogin')
  logOutSuccess(false)
  redirectToLogin()
  // throw new Error('Please login first')
  isShow.value = false
}
const { $t } = getCurrentInstance().proxy
const $route = useRoute()
const companyName = ref('')
const $router = useRouter()
const bannerExpireTip = ref()
const isFloatAuth = ref(false) // 是否为浮动授权企业
function getDaysDiff(startDate, endDate) {
  const oneDay = 24 * 60 * 60 * 1000 // 一天的毫秒数
  const start = new Date(startDate) // 开始日期
  const end = new Date(endDate) // 结束日期

  // 计算两个日期之间的天数差，保留1位小数
  const diffDays = ((end - start) / oneDay).toFixed(1)

  return parseFloat(diffDays)
}
const getData = async () => {
  try {
    const res = await getCompanyDetail()

    if (res.data) {
      isFloatAuth.value = res.data.floatAuth
      companyName.value = res.data.companyName
      companyData.value = res.data
      isFloatingCompany.value = res.data.floatAuth
      // isFloatingCompany.value = 1
      if (res.data.expireTime === -1) {
        organizeExpiredTime.value = 10000
      }
      console.log(new Date())
      console.log(new Date(res.data.expireTime * 1000))
      console.log(getDaysDiff(new Date(), new Date(res.data.expireTime * 1000)), '-----ds')
      isExpired.value = getDaysDiff(new Date(), new Date(res.data.expireTime * 1000))
      // banner文案
      if (isExpired.value < 0) {
        organizeExpiredTime.value = isExpired.value
        bannerExpireTip.value = $t(`Your company's membership rights have expired and all membership rights are no longer available. Please contact UPDF sales today to renew your membership.`)
      } else {
        organizeExpiredTime.value = Math.ceil(getDaysDiff(new Date(), new Date(res.data.expireTime * 1000)))
        bannerExpireTip.value = $t(
          'Your company membership benefits will expire in {organizeExpiredTime} days and all membership benefits will be unavailable. Please contact UPDF sales promptly to renew your membership.',
          { organizeExpiredTime: organizeExpiredTime.value }
        )
      }
    }
  } catch (error) {
    console.log(error)
    if (error.code === 403 || error.code === 500) {
      isDisplayContent.value = false
    }
  }
}
// eslint-disable-next-line no-unused-vars
$router.afterEach((to, from) => {
  if ((to.name === 'companySettings' && from.name === 'companyStaff') || (from.name === 'companyHome' && to.name === 'companySettings')) {
    getData()
  }
})

if (isShow.value) {
  getData()
}
// 展开菜单
const handleOpen = key => {
  console.log(key)
}
// 收起菜单
const handleClose = key => {
  console.log(key)
}
</script>

<style lang="scss"></style>

<style lang="scss" scoped>
.organize-banner {
  position: absolute;
  z-index: 1000;
  top: 0;
  width: 100%;
  background: #4c2fffe5;
  color: #ffffff;
  padding: 12px 130px 12px 130px;
  border-radius: 8px;
  box-sizing: border-box;
  text-align: center;
  width: 99%;
  left: 50%;
  font-size: 16px;
  transform: translateX(-50%);

  .close-icon {
    display: inline-block;
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    background: url('../../../assets/close-banner.png') no-repeat;
    width: 24px;
    height: 24px;
    background-size: cover;
    cursor: pointer;
    &:hover {
      background: url('../../../assets/close-banner-hover.png') no-repeat;
      background-size: cover;
    }

    &:active {
      background: url('../../../assets/close-banner-active.png') no-repeat;
      background-size: cover;
    }
  }
}
.bug-message {
  .el-button {
    color: #fff;
    // background-color: #c08fff;
    background-color: #333333;

    border-color: #409eff;
    outline: 0;
    box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
  }
}
.company-header {
  :deep(.user-avatar-img) {
    img {
      border-radius: 0 !important;
      box-shadow: 0;
    }
  }

  :deep(.user-avatar-text) {
    border-radius: 0 !important;
  }
}

.home {
  font-family: 'SF Pro';
}
.img-avator {
  border-radius: 50%;
}

.permission-box {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;

  .permission-inner {
    .permission-img {
      width: 93px;
      height: 103px;

      margin: 0 auto;
      display: block;
    }

    .permission-text {
      // font-family: 'SF Pro';
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      /* identical to box height, or 150% */
      margin-top: 32px;
      text-align: center;
    }
  }
}

.home {
  display: flex;
  padding: 12px;
  background: #f6f6f6;
  height: 100%;
  box-sizing: border-box;

  .left-navigation {
    width: 279px;
    height: 100%;

    .el-col {
      height: 100%;

      .el-menu {
        height: 100%;
        background: #202020;
        border-radius: 10px;
        overflow: hidden;
        border-right: none;
        .el-menu-item {
          height: 44px;
          span {
            opacity: 0.5;

            &:hover {
              opacity: 1;
            }
          }
        }
        .is-active {
          span {
            opacity: 1;
          }
        }
        .company-header {
          display: flex;
          align-items: center;
          height: 74px;

          .header-info {
            display: flex;
            flex-direction: column;
            margin-top: 12px;
            p {
              font-style: normal;
              font-weight: 400;
              font-size: 10px;
              line-height: 12px;
              /* identical to box height */

              color: rgba(255, 255, 255, 0.4);
            }

            span {
              position: relative;
              top: -4px;
            }
          }

          :deep(.user-avatar-container) {
            width: 40px;
            height: 40px;
            margin: 12px 12px 0 20px;
            border-radius: 10px;
            overflow: hidden;
          }

          span {
            font-weight: 590;
            font-size: 20px;
            line-height: 24px;
            color: #ffffff;
            width: 150px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            // opacity: 0.5;
          }
        }

        :deep(.el-menu-item:hover) {
          background: rgba(255, 255, 255, 0.08);
          border-radius: 8px;
          opacity: 1;
          img {
            opacity: 1;
          }
        }

        :deep(.el-menu-item > img) {
          width: 24px;
          margin-right: 8px;
          opacity: 0.5;
        }

        .is-active {
          background: rgba(255, 255, 255, 0.2);
          border-radius: 8px;
          img {
            opacity: 1;
          }
        }

        .el-menu-item {
          margin: 12px;
        }
      }
    }
  }

  .right-container {
    flex: 1;
    overflow: auto;
    overflow-x: hidden;
    position: relative;
    .container {
      // height: 100%;
      padding: 16px 20px 0px 32px;
      height: 90%;

      .head-portrait {
        cursor: pointer;
        display: flex;
        justify-content: flex-end;
        width: 100.5%;
        position: absolute;
        top: 20px;
        right: 40px;
        z-index: 100;
        img {
          text-align: right;
          width: 40px;
          cursor: pointer;
          margin-right: 26px;
          height: 40px;
        }
      }
    }
  }
}

.img-function {
  padding: 6px 0;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  // font-family: 'SF Pro';
  font-style: normal;
  font-weight: 590;
  font-size: 14px;
  line-height: 17px;
  color: #ff6767;
  cursor: pointer;

  .sign-out {
    margin-left: -15px;
  }

  .fr-FR {
    margin-left: -30px;
    position: relative;
    top: 2px;
  }

  &:hover {
    background: rgba(255, 103, 103, 0.12);
    border-radius: 4px;
  }

  img {
    width: 24px;
  }
}

.ar-SA {
  .home .right-container .container .head-portrait {
    left: 40px;
    right: auto;
  }
}

@media screen and (max-width: 1500px) {
  .de-DE,
  .pt-BR,
  .it-IT {
    .home .left-navigation {
      width: 300px;
    }
  }
}

@media screen and (max-width: 750px) {
  .collopse-menu {
    position: fixed;
    font-size: 0;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 1001;
  }

  .shadowBg {
    // background: #000;
    opacity: 0.3;
    width: 100%;
    top: 0;
    height: 100%;
    position: absolute;
    z-index: 999;
    left: 0;
  }

  .bottom-header {
    position: absolute;
    top: 30px;
    left: 0;
    width: 100%;
    padding: 0 20px;
    height: 44px !important;
    > img {
      width: 28px;
    }
    > span {
      margin-left: 8px;
    }
  }

  .home .left-navigation {
    width: 279px;
  }

  .home {
    padding: 0;

    .right-container .container {
      padding: 0;
    }

    .right-container .container .head-portrait {
      top: 10px;
      display: flex;
      justify-content: space-between;
      right: 0;
      z-index: 1000;
      position: fixed;
      right: 1%;
      .menu-img-wrapper {
        width: 60px;
        height: 40px;

        .menu-img {
          width: 16px;
          height: 12px;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          margin-left: 21px;
        }
      }

      .el-tooltip__trigger {
        margin-right: 16px;
      }
    }
  }
}

@media screen and (max-width: 1200px) {
  .home .right-container .organize-banner {
    font-size: 12px;
    padding: 6px 30px;
    z-index: 2000;
  }
}

@media screen and (max-width: 800px) {
  .home .right-container .organize-banner {
    z-index: 2000;
    width: 100%;
    border-radius: 0;
  }
}
@media screen and (min-width: 768px) and (max-width: 1500px) {
  .home {
    .left-navigation {
      width: 270px;
    }
  }
}
</style>
